import useTemplateStatus from "./useTemplateStatus";

export default function useIsProductionTemplate() {
  const status = useTemplateStatus();
  return status === "PRODUCTION";
}
